// firestoreRefs.js  – helper for user-scoped refs
import { doc, collection } from 'firebase/firestore';
import { db } from '../firebase';

export const userDoc      = (uid) => doc(db, 'users', uid);
export const userJourneys = (uid) => collection(userDoc(uid), 'journeys');
export const userHostels  = (uid) => collection(userDoc(uid), 'hostels');
